var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M98.741,350.322a2.088,2.088,0,1,0,2.088,2.088A2.088,2.088,0,0,0,98.741,350.322Zm0,3.248a1.16,1.16,0,1,1,1.16-1.16A1.16,1.16,0,0,1,98.741,353.57Z",
    transform: "translate(-91.005 -329.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M297.272,350.322a2.088,2.088,0,1,0,2.088,2.088A2.088,2.088,0,0,0,297.272,350.322Zm0,3.248a1.16,1.16,0,1,1,1.16-1.16A1.16,1.16,0,0,1,297.272,353.57Z",
    transform: "translate(-277.076 -329.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M24.882,10.353a.7.7,0,0,0-.464-.258L5.539,9.8,5.017,8.029a2.709,2.709,0,0,0-2.494-2H.58a.649.649,0,0,0,0,1.291H2.523a1.533,1.533,0,0,1,1.392,1.13L7.6,20.81l-.29.742a3.4,3.4,0,0,0,.261,2.808,2.648,2.648,0,0,0,2.175,1.356H21.025a.649.649,0,0,0,0-1.291H9.744a1.456,1.456,0,0,1-1.218-.775A1.95,1.95,0,0,1,8.381,22.1l.232-.581L20.822,20.1a3.33,3.33,0,0,0,2.755-2.711L24.969,10.9A.6.6,0,0,0,24.882,10.353ZM22.446,17.1a2.053,2.053,0,0,1-1.769,1.711L8.613,20.2l-2.7-9.1,17.777.29Z",
    transform: "translate(0 -6.028)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8938aebd2ad407973257193bd5445a27.svg";
export { ForwardRef as ReactComponent };